import * as React from 'react';
import './loader.scss';

import classNames from 'classnames';
import { Spin } from 'antd';
import { Dot9loader } from 'molecules/dot9loader';

type LoaderProps = {
	isInset?: boolean;
	size?: 'small' | 'medium' | 'large';
};

export default function Loader({ isInset = false, size = 'medium' }: Readonly<LoaderProps>) {
	return <Dot9loader compact={size === 'small'} />;
}

type LoaderWrapProps = {
	isInset?: boolean;
	isLoading: boolean;
	children: React.ReactNode;
};

export function LoaderWrap({ isInset = false, children, isLoading }: Readonly<LoaderWrapProps>) {
	return (
		<Spin spinning={isLoading} wrapperClassName="loader--wrap" indicator={<Loader isInset={isInset} />}>
			{children}
		</Spin>
	);
}
